/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const ContactCenter = defineMessages({
  stepDescription: {
    id: 'ContactCenter.stepDescription',
    defaultMessage: 'Give your system a voice to help customers over the phone.'
  },
  rightArrowLabel: {
    id: 'ContactCenter.rightArrowLabel',
    defaultMessage: 'Right arrow'
  },
  learnMore: {
    id: 'ContactCenter.learnMore',
    defaultMessage: 'Learn more'
  },
  connectToContactCenterTabTitle: {
    id: 'ContactCenter.connectToContactCenterTabTitle',
    defaultMessage: 'Contact center integrations'
  },
  connectToContactSetupInformation: {
    id: 'ContactCenter.connectToContactSetupInformation',
    defaultMessage: 'Setup information'
  },
  connectToContactCenterTabDescription: {
    id: 'ContactCenter.connectToContactCenterTabDescription',
    defaultMessage:
      'With a service desk connection, your assistant can transfer users to live agents. <link>Learn more</link>'
  },
  connectToContactCenterTitle: {
    id: 'ContactCenter.connectToContactCenterTitle',
    defaultMessage: 'Connect to your {contactCenter} account'
  },
  connectToContactCenterInstruction: {
    id: 'ContactCenter.connectToContactCenterInstruction',
    defaultMessage:
      'Add the account key of the {contactCenter} account that you want to connect to your assistant.'
  },
  connectToContactCenterNote: {
    id: 'ContactCenter.connectToContactCenterNote',
    defaultMessage:
      "Note: You must have administrative access to your organization's {contactCenter} account to complete this."
  },
  contactCenterStepDescription: {
    id: 'ContactCenter.contactCenterStepDescription',
    defaultMessage:
      'With a contact center connection, your assistant can transfer users to live agents. <link>Learn more</link>'
  },
  contactIdInputPlaceHolder: {
    id: 'ContactCenter.contactIdInputPlaceHolder',
    defaultMessage: 'X-ContactID'
  },
  contactIdInputLabel: {
    id: 'ContactCenter.contactIdInputLabel',
    defaultMessage: 'Contact ID'
  },
  contactIdInputTooltip: {
    id: 'ContactCenter.contactIdInputTooltip',
    defaultMessage: 'The SIP header field name that contains the Contact ID'
  },
  connectToContactCredentials: {
    id: 'ContactCenter.connectToContactCredentials',
    defaultMessage: 'Credentials'
  },
  accessKeyIdInputLabel: {
    id: 'ContactCenter.accessKeyIdInputLabel',
    defaultMessage: 'Access key ID'
  },
  accessKeyIdInputPlaceHolder: {
    id: 'ContactCenter.accessKeyIdInputPlaceHolder',
    defaultMessage: 'Enter {contactCenter} access key ID'
  },
  accessKeySecretInputLabel: {
    id: 'ContactCenter.accessKeySecretInputLabel',
    defaultMessage: 'Access key secret'
  },
  accessKeySecretInputPlaceHolder: {
    id: 'ContactCenter.accessKeyIdInputPlaceHolder',
    defaultMessage: 'Enter {contactCenter} access key secret'
  },
  connectAccountButton: {
    id: 'ContactCenter.connectAccountButton',
    defaultMessage: 'Test connection'
  },
  connected: {
    id: 'ContactCenter.connected',
    defaultMessage: 'Connected'
  },
  connecting: {
    id: 'ContactCenter.connecting',
    defaultMessage: 'Attempting to connect...'
  },
  notConnected: {
    id: 'ContactCenter.notConnected',
    defaultMessage:
      'Unable to connect. Please verify your account information and try again.'
  },
  iconDescription: {
    id: 'ContactCenter.iconDescription',
    defaultMessage: 'Input description'
  },
  instanceArnInputLabel: {
    id: 'ContactCenter.instanceArnInputLabel',
    defaultMessage: 'Amazon Connect Instance ARN'
  },
  instanceArnInputPlaceHolder: {
    id: 'ContactCenter.instanceArnInputPlaceHolder',
    defaultMessage:
      'For example: arn:aws:connect:endpoint:example:instance/asdfghjkl'
  },
  instanceArnInputTooltip: {
    id: 'ContactCenter.instanceArnInputTooltip',
    defaultMessage: 'Find your ARN'
  },
  apiKeyLabel: {
    id: 'ContactCenter.apiKeyLabel',
    defaultMessage: 'API key'
  },
  apiKeyPlaceHolder: {
    id: 'ContactCenter.apiKeyPlaceHolder',
    defaultMessage: 'Enter API key'
  },
  clientSecretLabel: {
    id: 'ContactCenter.clientSecretLabel',
    defaultMessage: 'Client secret'
  },
  clientSecretPlaceHolder: {
    id: 'ContactCenter.clientSecretPlaceHolder',
    defaultMessage: 'Enter base-64 encoded client secret'
  },
  genesysAudioConnectorInstructions: {
    id: 'ContactCenter.genesysAudioConnectorInstructions',
    defaultMessage: `The Genesys audio connector API key, Client secret, and connect URI are generated automatically. Be sure to copy and store these credentials in a safe place as you won't be able to access them here later. You will need to paste these credentials into the Genesys audio connector during set up.`
  },
  generatedConnectURILabel: {
    id: 'ContactCenter.genesysAudioConnectorInstructions',
    defaultMessage: 'Genesys audio connect URI'
  },
  botConnectorIdLabel: {
    id: 'ContactCenter.botConnectorIdLabel',
    defaultMessage: 'Bot Connector ID'
  },
  connectErrorTitleGenesys: {
    id: 'GenesysBotConnector.ConfigureGenesysBotConnectorStepMessages.webhookErrorTitleGenesys',
    defaultMessage:
      "We're unable to generate connect URI for your Genesys audio connector account for now."
  },
  connectErrorSubtitleGenesys: {
    id: 'GenesysBotConnector.ConfigureGenesysBotConnectorStepMessages.webhookErrorSubtitleGenesys',
    defaultMessage:
      'Please check the API key and client Client Secret and try again later.'
  },
  important: {
    id: 'GenesysBotConnector.ConfigureGenesysBotConnectorStepMessages.important',
    defaultMessage: 'Important: '
  }
});
